<template>
  <alert class="opc-support-coupon-banner" v-if="visible" type="success">
    <img slot="icon" :src="fileMap.icon" alt="coupon icon" class="opc-support-coupon-banner__icon" />
    <h3 slot="title" class="opc-support-coupon-banner__title">
      {{ $t('billing.coupon.support_coupon.offer_desc', [supportCouponState.discountPercentage]) }}
    </h3>
    <zm-button data-testid="checkout-button-383" :loading="verifyLoading" class="opc-support-coupon-banner__redeem" type="link" @click="handleRedeem">{{$t('billing.coupon.support_coupon.redeem_btn')}}</zm-button>
  </alert>
</template>

<script>
import Alert from '@/components/zoom-ui-plus/alert/alert';
import CouponIcon from '@/assets/coupon/coupon-icon.svg';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { SupportCouponModeMap } from '@/views/config/coupon/component/support-coupon/constant';

export default {
  name: 'SupportCouponBanner',
  components: { Alert },
  data() {
    return {
      fileMap: Object.freeze({
        icon: CouponIcon,
      }),
      verifyLoading: false,
    };
  },
  computed: {
    ...mapGetters(['supportCouponState', 'useSpecialSupportCoupon', 'supportCouponCode']),
    visible() {
      return this.useSpecialSupportCoupon && this.supportCouponState?.couponDisplayMode === SupportCouponModeMap.banner;
    },
  },
  methods: {
    ...mapMutations(['setSupportCouponState']),
    ...mapActions(['verifySupportCoupon']),
    async handleRedeem() {
      try {
        this.verifyLoading = true;
        await this.verifySupportCoupon({ couponCode: this.supportCouponCode });
      } finally {
        this.setSupportCouponState({ couponDisplayMode: SupportCouponModeMap.form });
        this.verifyLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.opc-cart__upper:has(.opc-support-coupon-banner) {
  padding-top: 32px !important;
}

.opc-support-coupon-banner {
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .zm-alert__icon {
    margin-right: 8px !important;
  }

  &__icon {

  }

  &__title {
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    text-align: left;
    color: #00053D;
    padding-bottom: 4px;
  }

  &__redeem {
    font-size: 16px;
    font-weight: 500;
    line-height: 19.2px;
    text-align: left;
    color: #0B5CFF;

    &.zm-button--small {
      padding: 0px;
    }
  }
}
</style>
